import { useLocalStorageState } from "@outschool/local-storage";
import { dayjs } from "@outschool/time";
import { useSession } from "@outschool/ui-auth";
import {
  useIsEligibleFor40PercentCouponUpsell,
  useRequiresMembershipForEnrollment
} from "@outschool/ui-components-website";

export default function useCDPMembershipModal() {
  const {
    requiresMembershipForEnrollment,
    requiresEsaMembershipForEnrollment
  } = useRequiresMembershipForEnrollment();
  const { isEligibleFor40PercentCouponUpsell } =
    useIsEligibleFor40PercentCouponUpsell();
  const { currentUser } = useSession();
  const [cdpMembershipModalDismissedAt, setCdpMembershipModalDismissedAt] =
    useLocalStorageState<string | null>("CDPMembershipModalDismissedAt", null);

  const isMembershipNeeded =
    (requiresMembershipForEnrollment &&
      (!currentUser?.hasSubscription ||
        !currentUser?.canPayWithSubscriptionCredits) &&
      !currentUser?.hasEsaMembership) ||
    requiresEsaMembershipForEnrollment;

  const isSnoozed =
    cdpMembershipModalDismissedAt &&
    dayjs(cdpMembershipModalDismissedAt).isAfter(dayjs().subtract(24, "hours"));

  // show the modal when:
  // 1) membership is required, OR
  // 2) a la carte user is being offered the coupon AND they have not snoozed the modal
  const shouldShowCDPMembershipModal =
    isMembershipNeeded || (isEligibleFor40PercentCouponUpsell && !isSnoozed);

  return {
    snoozeCDPMembershipModal: () =>
      setCdpMembershipModalDismissedAt(new Date().toISOString()),
    shouldShowCDPMembershipModal
  };
}
